<div class="login-content col-md-5">
  <div class="card card-user">
    <div class="card-header">
      <h5 class="card-title">Register</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="registerForm" (ngSubmit)="register()">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Username: </label>
              <input type="email" [ngClass]="{'is-invalid': registerForm.get('username').errors
                && registerForm.get('username').touched}" 
                class="form-control" formControlName="username" placeholder="Input your email"/>
              <div class="invalid-feedback text-danger mt-1"><small>Please choose a valid username</small></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Full Name: </label>
              <input type="text" [ngClass]="{'is-invalid': registerForm.get('displayname').errors
                && registerForm.get('displayname').touched}"
                class="form-control" formControlName="displayname" placeholder="Input your full name">
                <div class="invalid-feedback text-danger mt-1"><small>Display Name is required</small></div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Password:</label>
              <input type="password" [ngClass]="{'is-invalid': registerForm.get('password').errors
                && registerForm.get('password').touched}" 
                class="form-control"  formControlName="password" placeholder="Password">
              <div class="invalid-feedback text-danger mt-1" *ngIf="registerForm.get('password').hasError('required')
                && registerForm.get('password').touched"><small>Password is required</small></div>
              <div class="invalid-feedback text-danger mt-1" *ngIf="registerForm.get('password').hasError('minlength')
                && registerForm.get('password').touched"><small>Password must be at least 4 characters</small></div>
              <div class="invalid-feedback text-danger mt-1" *ngIf="registerForm.get('password').hasError('maxlength')
                && registerForm.get('password').touched"><small>Password cannot exceed 8 characters</small></div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Confirm Password:</label>
              <input type="password" [ngClass]="{'is-invalid': registerForm.get('confirmpassword').errors
                && registerForm.get('confirmpassword').touched
                || registerForm.get('confirmpassword').touched
                && registerForm.hasError('mismatch')}"
               class="form-control" formControlName="confirmpassword" placeholder="Password">
               <div class="invalid-feedback text-danger mt-1" *ngIf="registerForm.get('confirmpassword').hasError('required')
                && registerForm.get('confirmpassword').touched"><small>Password is required</small></div>
                <div class="invalid-feedback text-danger mt-1" *ngIf="registerForm.hasError('mismatch')
                && registerForm.get('confirmpassword').touched"><small>Password must match</small></div>                
            </div>
          </div>
        </div>

        <div class="row">
          <div class="update ml-auto mr-auto">
            <button type="submit" class="btn btn-primary btn-round">
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span> Register</span></button>
          </div>
        </div>
        <div class="row">
          <div class="update ml-auto mr-auto">
            <span>Already a member?</span><a class="ml-1" [routerLink]="" (click)="actionChanged()">Log In</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>  




